import {
  acquisitionCampaign,
  acquisitionSessionId,
  loadAcquisitionDraft,
} from "./acquisitionFunnel";

// # PUBLIC ENTRY: home -> one account form -> the existing dashboard.
// A separate cohort keeps the former diagnostic funnel comparable.
// Never put passwords or contact details in URLs, telemetry or browser storage.
export const PUBLIC_REGISTRATION_VERSION = "wp-home-signup-2026-11-v1";
const CAMPAIGN_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

export function publicRegistrationContext(search = "") {
  // Support both HashRouter queries and normal campaign URLs.
  const params = new URLSearchParams(
    typeof window === "undefined" ? "" : window.location.search,
  );
  new URLSearchParams(search).forEach((value, key) => params.set(key, value));
  const sessionId = acquisitionSessionId();
  const stored = loadAcquisitionDraft() || {};
  const draft = stored.sessionId === sessionId ? stored : {};
  const referralCode = String(
    params.has("ref") ? params.get("ref") : draft.referralCode || "",
  )
    .trim()
    .toUpperCase();
  const hasCampaign = CAMPAIGN_KEYS.some((key) => params.has(key));
  const campaign = hasCampaign
    ? acquisitionCampaign(params)
    : draft.campaign || acquisitionCampaign(params);
  return { params, referralCode, campaign, sessionId };
}

export function publicRegistrationPath(
  search = "",
  entryPoint = "home-start",
  destination = "/registro",
) {
  const {
    params: source,
    referralCode,
    campaign,
  } = publicRegistrationContext(search);
  const params = new URLSearchParams();
  if (referralCode) params.set("ref", referralCode);
  CAMPAIGN_KEYS.forEach((key) => {
    const value = source.get(key) || campaign[key.replace("utm_", "")];
    if (value) params.set(key, value);
  });
  // Old quick-entry links keep optional intent, without another mandatory step.
  if (source.get("need")) params.set("need", source.get("need").slice(0, 80));
  if (entryPoint) params.set("entry", entryPoint);
  return `${destination}${params.toString() ? `?${params.toString()}` : ""}`;
}

export function registrationFieldErrors({ name, email, password }) {
  const errors = {};
  if (!String(name || "").trim()) errors.name = "Ingresá tu nombre.";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim()))
    errors.email = "Ingresá un email válido, por ejemplo nombre@correo.com.";
  if (String(password || "").length < 8)
    errors.password = "Usá al menos 8 caracteres.";
  else if (password.length > 128) errors.password = "Usá hasta 128 caracteres.";
  return errors;
}
